
























































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore } from '@/store'
import _ from 'lodash'

@Component
export default class CoreBonuses extends Vue {
  private compendium = getModule(CompendiumStore, this.$store)
  get bonuses() {
    return _.groupBy(
      this.compendium.CoreBonuses.filter(x => !x.IsHidden),
      'Source'
    )
  }

  public manufacturer(id: string) {
    const compendium = getModule(CompendiumStore, this.$store)
    return compendium.Manufacturers.find(x => x.ID === id.toUpperCase())
  }
}
